import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API, withCredentials: true });

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// ---- Anonymous visitor + attribution ----
export function getVisitorId() {
  let v = localStorage.getItem("isc_visitor");
  if (!v) {
    v = "v-" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("isc_visitor", v);
  }
  return v;
}

export function trackVisit(landing, cluster = "") {
  try {
    const params = new URLSearchParams(window.location.search);
    const ref = document.referrer || "";
    let source = "direct", medium = "none";
    if (params.get("utm_source")) { source = params.get("utm_source"); medium = params.get("utm_medium") || "cpc"; }
    else if (ref.includes("google")) { source = "organic"; medium = "organic"; }
    else if (ref) { source = "referral"; medium = "referral"; }
    http.post("/track", {
      visitor_id: getVisitorId(), source, medium,
      campaign: params.get("utm_campaign") || "", landing, cluster, referrer: ref,
    }).catch(() => {});
  } catch (e) {}
}

// ---- Internal traffic (owner/admin/operator/test) → kept out of production GA4 reporting ----
export function setInternalTraffic(isInternal) {
  try {
    if (isInternal) localStorage.setItem("isc_internal", "1");
    else localStorage.removeItem("isc_internal");
  } catch (e) {}
}
export function isInternalTraffic() {
  try { return localStorage.getItem("isc_internal") === "1"; } catch (e) { return false; }
}

// GA4-safe event: never send sensitive intake content.
// opts.once → de-duplicate per browser session (prevents re-mount / StrictMode double-counts).
// opts.key → optional discriminator so the same event can fire once per distinct key.
export function trackEvent(event, props = {}, opts = {}) {
  try {
    if (opts.once) {
      const dedupeKey = `isc_ev_once_${event}${opts.key ? ":" + opts.key : ""}`;
      try {
        if (sessionStorage.getItem(dedupeKey)) return;
        sessionStorage.setItem(dedupeKey, "1");
      } catch (e) {}
    }
    const internal = isInternalTraffic();
    http.post("/analytics/event", { event, visitor_id: getVisitorId(), props, internal }).catch(() => {});
    if (window.gtag) {
      // Internal traffic → tag + route to DebugView so it is excluded from standard GA4 reports.
      const params = internal ? { ...props, traffic_type: "internal", debug_mode: true } : props;
      window.gtag("event", event, params);
    }
  } catch (e) {}
}

// Fire a GA4 conversion event directly via gtag (no internal logging).
// debug=true routes the event to GA4 DebugView and excludes it from standard reports (Stripe test mode).
export function gaEvent(event, params = {}, debug = false) {
  try {
    const internal = isInternalTraffic();
    const dbg = debug || internal;
    if (window.gtag) window.gtag("event", event, dbg ? { ...params, debug_mode: true, ...(internal ? { traffic_type: "internal" } : {}) } : params);
  } catch (e) {}
}
